// Sortable
import { moveItemInList } from 'mdb-sortable';
// tables
import {
  Component, OnInit, ElementRef, HostListener,
  AfterViewInit, ViewChild, ChangeDetectorRef,
  QueryList, ViewChildren
} from '@angular/core';
import { MdbTableDirective, MdbTablePaginationComponent, MdbBtnDirective, MDBModalRef } from 'ng-uikit-pro-standard';
// mensage type  toast
import { ToastService } from 'ng-uikit-pro-standard';
// forms and validations
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { ComponentsType, ComponentIndicator, ComponentChart, ChartDatasets, ChartColors, Dashboard } from 'src/app/models/component-data';
import { DasboardService } from 'src/app/services/dashboard.service';
import { TranslateService } from '@ngx-translate/core';
import { groupBy, mergeMap, toArray } from 'rxjs/operators';
import { from, Observable } from 'rxjs';
import { GetTypePipe } from 'src/app/custom-pipe/GetTypePipe';
import { AppConfigService } from 'src/app/app-config.service.service';
import { ProjectService } from 'src/app/services/project.service';
import { DatePipe } from '@angular/common';
import { GeneralService } from 'src/app/services/general.service';
import { Router } from '@angular/router';

@Component({
  selector: 'card-list-phases',
  templateUrl: './card-list-phases.component.html',
  styleUrls: ['./card-list-phases.component.scss']
})
export class CardListPhasesComponent implements OnInit {
 
  segmentSelected = 1;
  segmentItems: any[] = [
    {
      Id: 1,
      Name: 'Status'
    },
    {
      Id: 2,
      Name: 'Phases'
    }
  ]
  lists: any[] = [];
  statuses: string[];
  ProyectsGrouped: any = [];
  DataPS = {
    Phase: [],
    Status: []
  }
  ProjectPhases = [];
  ProjectStatus = [];
  DataList = []
  gridDataSource: any[] = [];
  popup_bool: boolean = false;
  popup_bool_list: boolean = false;
  editinsert_SP: boolean = null;
  FormEditPhase: FormGroup;
  FormEditStatus: FormGroup;
  filterValue = [
    ['StatusName', '=', 'Not Started'],
    'or',
    ['StatusName', "=", 'In Progress']
  ];
  DataProjectProgress: any[] = []
  todayButton: any;
  prevDateButton: any;
  nextDateButton: any;
  editapprovedbool: boolean = false;
  millisecondsInDay = 24 * 60 * 60 * 1000;
  DateFilter: any = new Date();
  dateFormat = '';
  moneyFormat = '';
  formProgressReport: FormGroup
  projectslist: any[] = []

  popupNewReport: boolean = false;
  popupEmailInvoice: boolean = false;

  constructor(
    private ProjectService: ProjectService,
    private datePipe: DatePipe,
    private translateService: TranslateService,
    // private translatePipe: TranslatePipe,
    private appConfigService: AppConfigService,
    public generalService: GeneralService,
    private toast: ToastService,
    private router: Router) {

    this.dateFormat = this.appConfigService.dateFormat;
    this.moneyFormat = this.appConfigService.moneyFormat;

  }
prueba:boolean=false
  ngOnInit() {
    console.log("asda")
    this.ProjectService.Get_ProjectByStatusandPhaseCE().subscribe(result => {
      this.DataList = result
      console.log(this.DataList)
      this.Get_ProjectStatus();
      this.Get_ProjectPhases();
    })
  }

/********** Phases************************************* */

  Get_ProjectStatus() {
    this.ProjectStatus = []
    this.ProjectService.Get_ProjectStatus().subscribe(
      data => {
        this.DataPS.Status = data;
        data.map((val) => {
          if (val.ACTIVE) {
            let obj = {
              Id: val.ID,
              ACTIVE: val.ACTIVE,
              NAME: val.NAME,
              Filter: {
                pageindex: 1, pagesize: 30, orderid: 1, bidstatus: val.ID
              },
              Color: this.generalService.GetColorBidStatus(val.ID),
              Data: []
            }
            this.ProjectStatus.push(obj);
            return { // Return the new object structure
              label: val.NAME,
              value: val.ID
            };
          }
        });
        this.changeSegment();
      },
      err => {
        console.log(err);
      }
    );
  }

  Get_ProjectPhases() {
    this.ProjectPhases = []
    this.ProjectService.Get_ProjectPhasesCE().subscribe(
      data => {
        this.DataPS.Phase = data;
        data.map((val) => {
          if (val.ACTIVE) {
            let obj = {
              ID: val.ID,
              ACTIVE: val.ACTIVE,
              NAME: val.NAME,
              Filter: {
                pageindex: 1, pagesize: 30, orderid: 1, bidstatus: val.ID
              },
              Color: this.generalService.GetColorBidStatus(val.ID),
              Data: []
            }
            this.ProjectPhases.push(obj);
            return { // Return the new object structure
              label: val.NAME,
              value: val.ID
            };
          }
        });
        this.changeSegment();
      },
      err => {
        console.log(err);
      }
    );
  }

  changeSegment() {
    let values = [];
    console.log(this.segmentSelected)
    switch (this.segmentSelected) {
      case 1:
        values = this.ProjectStatus.map(({ ID }) => ID)
        break;
      case 2:
        values = this.ProjectPhases.map(({ ID }) => ID)
        break;
      default:
        values = []
        break;

    }

    this.GetLeadByField(values.join(','), null);
  }

  GetLeadByField(estatus = '', filter = null) {
    let type = this.segmentSelected;

    this.ProyectsGrouped = [];

    switch (type) {
      case 1:
        this.ProyectsGrouped = this.ProjectStatus;
        if (filter) {
          filter.pageindex = filter.pageindex + 1;
        } else {
          filter = { pageindex: 1, pagesize: 30, orderid: 1, bidstatus: estatus };
        }
        break;
      case 2:
        this.ProyectsGrouped = this.ProjectPhases;
        if (filter) {
          filter.pageindex = filter.pageindex + 1;
        } else {
          filter = { pageindex: 1, pagesize: 30, orderid: 1, bidstatus: estatus };
        }
        break;
      default:
        this.ProyectsGrouped = [];
        break;
    }
    for (let index = 0; index < this.DataList.length; index++) {
      const element = this.DataList[index];
      // console.log(element)
      let cuont: any;
      let boolexist: boolean = false;
      switch (this.segmentSelected) {
        case 1:
          cuont = this.ProyectsGrouped.find(x => x.NAME == element.Status);
          if (cuont) {
            cuont.Data.forEach(element2 => {
              if (element2.ID == element.ID) {
                boolexist = true;
              }
            });
            if (boolexist == false) {
              cuont.Data.push(element)
            }
          }

          break;
        case 2:
          cuont = this.ProyectsGrouped.find(x => x.NAME == element.Phase);
          if (cuont) {
            cuont.Data.forEach(element2 => {

              if (element2.ID == element.ID) {
                boolexist = true;
              }
            });
            if (boolexist == false) {
              cuont.Data.push(element)
            }
          }
          break;
      }
    }
    // for (let i = 0; i < 30; i++) {
    //   this.ProyectsGrouped.push(this.ProyectsGrouped[0])
    // }
    this.prueba = true
  }

  onTaskDragStart(e) {
    e.itemData = e.fromData[e.fromIndex];
  }

  onTaskDrop(e, item) {
    switch (this.segmentSelected) {
      case 1:
        this.ProjectService.ProjectBillingStatusCE(e.itemData.ID, item.Id).subscribe(result => {
          e.fromData.splice(e.fromIndex, 1);
          e.toData.splice(e.toIndex, 0, e.itemData);
          // this.GetLeadByField(item.Id, item.Filter);
        });
        break;
      case 2:
        this.ProjectService.Update_ProjectPhasesCE(e.itemData.ID, item.ID).subscribe(result => {
          e.fromData.splice(e.fromIndex, 1);
          e.toData.splice(e.toIndex, 0, e.itemData);
          // this.GetLeadByField(item.Id, item.Filter);
        });
        break;
    }

  }

  inicializarScroll() {
    // para poder eliminar el loading que crea el control por defecto
    $('.dx-scrollview-scrollbottom-indicator').remove();
  }

  splip_icon(data, index) {
    let value: string = data.ico_Status;
    let splititem;
    if (value != null) {
      splititem = value.split("/");
    } else {
      splititem = [" ", " "]
    }
    return splititem[index];
  }

  save_edit(event) {
    this.popup_bool = false;
    this.popup_bool_list = false;
    let item = event.data;
    if (item.NAME == undefined) {
      this.toast.error("requires NAME")
      this.Get_ProjectStatus();
      this.Get_ProjectPhases();
      return false;
    }
    if (item.SORT == undefined) {
      this.toast.error("requires SORT")
      this.Get_ProjectStatus();
      this.Get_ProjectPhases();
      return false;
    }
    switch (this.segmentSelected) {
      case 1:
        if (item.NAME == undefined) {
          this.toast.error("requires NAME")
          this.Get_ProjectStatus();
          return false;
        }
        if (item.SORT == undefined) {
          this.toast.error("requires SORT")
          this.Get_ProjectStatus();
          return false;
        }
        item = {
          id: 0,
          active: item.ACTIVE == undefined ? true : item.ACTIVE,
          status: item.NAME == undefined ? '' : item.NAME,
          sort: item.SORT == undefined ? '' : item.SORT,
        };
        this.ProjectService.Get_InserUpdateProjectStatusCE(item).subscribe(data => {
          this.toast.success("successfully updated")
          this.Get_ProjectStatus();
        }, err => {
          this.toast.error(err)
        })
        break;
      case 2:
        if (item.NAME == undefined) {
          this.toast.error("requires NAME")
          this.Get_ProjectPhases();
          return false;
        }
        if (item.SORT == undefined) {
          this.toast.error("requires SORT")
          this.Get_ProjectPhases();
          return false;
        }
        item = {
          id: 0,
          active: item.ACTIVE == undefined ? true : item.ACTIVE,
          name: item.NAME == undefined ? '' : item.NAME,
          sort: item.SORT == undefined ? '' : item.SORT,
          decripton: item.DESCRIPTION == undefined ? '' : item.DESCRIPTION
        };
        this.ProjectService.Get_InserUpdateProjectPhasesCE(item).subscribe(data => {
          this.toast.success("successfully updated")
          this.Get_ProjectPhases();
        }, err => {
          this.toast.error(err)
        })
        break;
    }
  }
  
  width_calculate(length) {
    let wd = (100 / length.length) + "%"
    return wd;
  }

  view_item_phase_status() {
    this.editinsert_SP = true;
    this.popup_bool = true;
    this.popup_bool_list = true;
  }
  
  onListReorder(e) {
    const list = this.lists.splice(e.fromIndex, 1)[0];
    this.lists.splice(e.toIndex, 0, list);

    const status = this.statuses.splice(e.fromIndex, 1)[0];
    this.statuses.splice(e.toIndex, 0, status);
  }

  update(obj) {
    let olddata = obj.oldData;
    let newData = obj.newData;
    let item
    switch (this.segmentSelected) {
      case 1:
        item = {
          id: olddata.ID,
          active: newData.ACTIVE == undefined ? olddata.ACTIVE : newData.ACTIVE,
          status: newData.NAME ? newData.NAME : olddata.NAME,
          sort: newData.SORT ? newData.SORT : olddata.SORT,
        };
        this.ProjectService.Get_InserUpdateProjectStatusCE(item).subscribe(data => {
          this.toast.success("successfully updated")
          this.Get_ProjectStatus();
        })
        break;
      case 2:
        item = {
          id: olddata.ID,
          active: newData.ACTIVE == undefined ? olddata.ACTIVE : newData.ACTIVE,
          name: newData.NAME ? newData.NAME : olddata.NAME,
          sort: newData.SORT ? newData.SORT : olddata.SORT,
          decripton: newData.DESCRIPTION ? newData.DESCRIPTION : olddata.DESCRIPTION
        };
        this.ProjectService.Get_InserUpdateProjectPhasesCE(item).subscribe(data => {
          this.toast.success("successfully updated")
          this.Get_ProjectPhases();
        })
        break;
    }
  }

  GoEditProject(data){
    this.router.navigate(['editProject'], { queryParams: { numID: data.ID } });
  }


  /************************************* */
}
